// tccmrt-future-v1: #8EC31C
// tccmrt-future-v2: #ea0437
// tccmrt-future-v3: #0070bd
// tccmrt-future-v4: #8f8c7b
// tccmrt-future-v6: #ff8000
// tccmrt-future-v7: #79bce8

export const lines = [
  //v1
  {
    name: '捷運綠線延伸：大坑延伸線',
    variant: 'tccmrt-future-v1',
    info: '可行性於2024年1月獲行政院核定，目前正規劃中，尚未確認',
  },
  //v1-1
  {
    name: '捷運綠線延伸：彰化延伸線',
    variant: 'tccmrt-future-v1',
    info: '可行性於2024年1月獲行政院核定，目前正規劃中，尚未確認',
  },
  // v1-2
  {
    name: '捷運藍線',
    variant: 'tccmrt-future-v3',
    info: '2024年1月獲行政院核定，將在2025動工，並預計在2034年完工通車',
  },
  // v1-3
  {
    name: '捷運藍線太平延伸線',
    variant: 'tccmrt-future-v3',
    info: '尚未核定，僅供參考',
  },
  // v1-4
  {
    name: '屯區捷運環狀線',
    variant: 'tccmrt-future-v4',
    info: '尚未核定，僅供參考',
  },
  // v1-5
  {
    name: '機場捷運橘線',
    variant: 'tccmrt-future-v6',
    info: '尚未核定，僅供參考',
  },
  // v2
  {
    name: '山線',
    variant: 'tccmrt-future-v2',
    info: '尚未核定，僅供參考',
  },
  // v2-1
  {
    name: '海線雙軌暨部分高架',
    variant: 'tccmrt-future-v7',
    info: '尚未核定，僅供參考',
  },
]

export const stations = [
  // v1
  [
    {
      name: '圓山新村 101',
      address: '',
      lat: 24.177193,
      lng: 120.730342,
    },
    {
      name: '軍功寮 102',
      address: '',
      lat: 24.182087,
      lng: 120.719471,
    },
  ],
  // v1-1
  [
    {
      name: '成功嶺 G18',
      address: '',
      lat: 24.11143,
      lng: 120.600581,
    },
    {
      name: '榮泉/健行路口 G19',
      address: '',
      lat: 24.111068,
      lng: 120.593911,
    },

    {
      name: '金馬/彰興路口 G19a',
      address: '',
      lat: 24.095733,
      lng: 120.581687,
    },
    {
      name: '金馬/中山路口 G20',
      address: '',
      lat: 24.093376,
      lng: 120.568381,
    },
    {
      name: ' 金馬通勤站 G21',
      address: '',
      lat: 24.095214,
      lng: 120.56492,
    },
  ],
  // v1-2 捷運藍線
  [
    {
      name: '台中港站 B01',
      address: '',
      lat: 24.256409,
      lng: 120.525725,
    },
    {
      name: '梧棲站 (梧棲國小) B02',
      address: '',
      lat: 24.252804,
      lng: 120.529753,
    },
    {
      name: '大庄站 (童綜合醫院) B03',
      address: '',
      lat: 24.247013,
      lng: 120.544297,
    },
    {
      name: '沙鹿站 B04',
      address: '',
      lat: 24.241552,
      lng: 120.559729,
    },
    {
      name: '竹林站 (沙鹿高工) B05',
      address: '',
      lat: 24.237638,
      lng: 120.569388,
    },
    {
      name: '靜宜大學站 B06',
      address: '',
      lat: 24.227128,
      lng: 120.575628,
    },
    {
      name: '弘光科大站 B07',
      address: '',
      lat: 24.217176,
      lng: 120.580654,
    },
    {
      name: '正英路站 B08',
      address: '',
      lat: 24.209749,
      lng: 120.581265,
    },
    {
      name: '東海別墅站 B09',
      address: '',
      lat: 24.182511,
      lng: 120.594307,
    },
    {
      name: '東海大學站 (榮總) B10',
      address: '',
      lat: 24.182978,
      lng: 120.602767,
    },
    {
      name: '澄清醫院站 B11',
      address: '',
      lat: 24.182905,
      lng: 120.615326,
    },
    {
      name: '福安站 (中港轉運站) B12',
      address: '',
      lat: 24.178469,
      lng: 120.624285,
    },
    {
      name: '朝馬站 B13',
      address: '',
      lat: 24.167897,
      lng: 120.641055,
    },
    {
      name: '市政府站 B14',
      address: '',
      lat: 24.162452,
      lng: 120.649566,
    },
    {
      name: '忠明國小站 B15',
      address: '',
      lat: 24.154632,
      lng: 120.66409,
    },
    {
      name: '科博館站 B16',
      address: '',
      lat: 24.157026,
      lng: 120.659668,
    },
    {
      name: '茄苳腳站 (五權路) B17',
      address: '',
      lat: 24.147683,
      lng: 120.673526,
    },
    {
      name: '第二市場站 B18',
      address: '',
      lat: 24.1425,
      lng: 120.679481,
    },
    {
      name: '台中車站 B19',
      address: '',
      lat: 24.138148,
      lng: 120.687801,
    },
    {
      name: '帝國製糖廠站 B20',
      address: '',
      lat: 24.135545,
      lng: 120.69303,
    },
  ],
  // v1-3 捷運藍線太平延伸線
  [
    {
      name: 'P20',
      address: '',
      lat: 24.131148,
      lng: 120.703708,
    },
    {
      name: 'P19',
      address: '',
      lat: 24.126823,
      lng: 120.711012,
    },
    {
      name: 'P18',
      address: '',
      lat: 24.130541,
      lng: 120.720827,
    },
    {
      name: 'P17',
      address: '',
      lat: 24.134244,
      lng: 120.726854,
    },
  ],
  // v1-4 屯區捷運環狀線
  [
    {
      name: 'P1/G01',
      address: '',
      lat: 24.175577,
      lng: 120.73026,
    },
    {
      name: 'P2',
      address: '',
      lat: 24.169388,
      lng: 120.727354,
    },
    {
      name: 'P3',
      address: '',
      lat: 24.16099,
      lng: 120.727361,
    },
    {
      name: 'P4',
      address: '',
      lat: 24.149578,
      lng: 120.723061,
    },
    {
      name: 'P5',
      address: '',
      lat: 24.142751,
      lng: 120.721267,
    },
    {
      name: 'P6',
      address: '',
      lat: 24.136133,
      lng: 120.715536,
    },
    {
      name: 'P7/P19',
      address: '',
      lat: 24.126823,
      lng: 120.711012,
    },
    {
      name: 'P8',
      address: '',
      lat: 24.116609,
      lng: 120.71343,
    },
    {
      name: 'P9',
      address: '',
      lat: 24.1106,
      lng: 120.711218,
    },
    {
      name: 'P10',
      address: '',
      lat: 24.10469,
      lng: 120.705927,
    },
    {
      name: 'P11',
      address: '',
      lat: 24.099746,
      lng: 120.695343,
    },
    {
      name: 'P12',
      address: '',
      lat: 24.100949,
      lng: 120.689758,
    },
    {
      name: 'P13',
      address: '',
      lat: 24.104877,
      lng: 120.681229,
    },
    {
      name: 'P14',
      address: '',
      lat: 24.105327,
      lng: 120.66704,
    },
    {
      name: 'P15',
      address: '',
      lat: 24.113073,
      lng: 120.657569,
    },
    {
      name: 'P16 大慶站',
      address: '',
      lat: 24.119663,
      lng: 120.649024,
    },
  ],
  // v1-5 橘線機場捷運
  [
    {
      name: '臺中國際機場 001',
      address: '',
      lat: 24.255109,
      lng: 120.599647,
    },
    {
      name: '公明 002',
      address: '',
      lat: 24.24726,
      lng: 120.606222,
    },
    {
      name: '清泉 003',
      address: '',
      lat: 24.243997,
      lng: 120.615058,
    },
    { name: '埔仔墘 004', address: '', lat: 24.241091, lng: 120.630302 },
    { name: '科雅 005', address: '', lat: 24.234638, lng: 120.636736 },
    {
      name: '大雅 006',
      address: '',
      lat: 24.225648,
      lng: 120.645321,
    },
    { name: '大華國中 007', address: '', lat: 24.216191, lng: 120.649251 },
    {
      name: '水湳轉運中心(會展中心) 008',
      address: '',
      lat: 24.198503,
      lng: 120.653533,
    },
    { name: '流行影音中心 009', address: '', lat: 24.185641, lng: 120.657809 },
    { name: '陳平 010', address: '', lat: 24.182802, lng: 120.665612 },
    {
      name: '文心中清(天津商圈) 011',
      address: '',
      lat: 24.173736,
      lng: 120.671164,
    },
    {
      name: '元保宮 012',
      address: '',
      lat: 24.162903,
      lng: 120.674636,
    },
    {
      name: '中國醫藥大學 013',
      address: '',
      lat: 24.157443,
      lng: 120.681028,
    },
    {
      name: '新民高中 014',
      address: '',
      lat: 24.156052,
      lng: 120.685605,
    },
    {
      name: '臺中科技大學 015',
      address: '',
      lat: 24.14982,
      lng: 120.684185,
    },
    {
      name: '臺中車站 016',
      address: '',
      lat: 24.137968,
      lng: 120.686131,
    },
    {
      name: '漫畫博物館 017',
      address: '',
      lat: 24.131918,
      lng: 120.676578,
    },
    {
      name: '中興大學 018',
      address: '',
      lat: 24.119131,
      lng: 120.679212,
    },
    {
      name: '大里仁愛醫院 019',
      address: '',
      lat: 24.109392,
      lng: 120.679843,
    },
    {
      name: '大里 020',
      address: '',
      lat: 24.104877,
      lng: 120.681229,
    },
    {
      name: '大里行政中心 021',
      address: '',
      lat: 24.098995,
      lng: 120.683045,
    },
    {
      name: '仁化 022',
      address: '',
      lat: 24.091983,
      lng: 120.691277,
    },
    {
      name: '軟體園區 023',
      address: '',
      lat: 24.085429,
      lng: 120.69662,
    },
    {
      name: '霧峰農工 024',
      address: '',
      lat: 24.075662,
      lng: 120.699954,
    },
    {
      name: '霧峰 025',
      address: '',
      lat: 24.068857,
      lng: 120.699132,
    },
    {
      name: '民主議政園區 026',
      address: '',
      lat: 24.056207,
      lng: 120.697535,
    },
  ],
  // v2 山線
  [
    {
      name: '豐原',
      address: '台中市豐原區中正路1號',
      lat: 24.254112,
      lng: 120.722917,
    },
    {
      name: '栗林(原豐南)',
      address: '',
      lat: 24.234681,
      lng: 120.710605,
    },
    {
      name: '潭子',
      address: '台中市潭子區中山路二段352號',
      lat: 24.2126188,
      lng: 120.7054928,
    },
    { name: '頭家厝', address: '', lat: 24.19535, lng: 120.703961 },
    { name: '松竹', address: '', lat: 24.180208, lng: 120.70197 },
    {
      name: '太原',
      address: '台中市北屯區東光路833號',
      lat: 24.16669,
      lng: 120.7000866,
    },
    { name: '精武', address: '', lat: 24.149038, lng: 120.697758 },
    {
      name: '台中車站',
      address: '台中市中區建國路172號',
      lat: 24.1368307,
      lng: 120.6848278,
    },
    { name: '五權', address: '', lat: 24.129392, lng: 120.666949 },
    { name: '大慶', address: '', lat: 24.119563, lng: 120.64873 },
    { name: '烏日', address: '', lat: 24.108743, lng: 120.622502 },
    {
      name: '新烏日(高鐵站)',
      address: '台中縣烏日鄉站區二路8號',
      lat: 24.1117337,
      lng: 120.6157348,
    },
    {
      name: '成功',
      address: '台中市烏日區中山路三段550號',
      lat: 24.1136912,
      lng: 120.590675,
    },
  ],
  // v2-1 海線雙軌暨部分高架
  [
    {
      name: '大甲',
      address: '',
      lat: 24.345465,
      lng: 120.627037,
    },

    {
      name: '台中港',
      address: '',
      lat: 24.304885,
      lng: 120.60239,
    },
    {
      name: '清水',
      address: '',
      lat: 24.263935,
      lng: 120.569214,
    },
    {
      name: '沙鹿',
      address: '',
      lat: 24.237289,
      lng: 120.557616,
    },
    {
      name: '龍井',
      address: '',
      lat: 24.197748,
      lng: 120.543363,
    },
    {
      name: '大肚',
      address: '',
      lat: 24.154314,
      lng: 120.542459,
    },
    {
      name: '追分',
      address: '',
      lat: 24.12086,
      lng: 120.570139,
    },
  ],
]
